import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'



class Admin extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #1a1a1a;
            padding: 200px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 1300px 0 50px 0;
            }
            @media (min-width:1025px) and (max-width:1500px) {
                padding: 250px 0 50px 0;              
            }
            @media (min-width:768px) and (max-width:1024px) {
                padding: 350px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 100px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
            margin-bottom: 0px;
        `

        const ServiceHeadinga = styled.a`
            font-family: Oswald;
            color: #7dfa06;
            transition: .5s;
            &:hover {
              color: #FFF;
              text-decoration: none;
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #84a841;
            margin-bottom: 5px;
        `

        const ServiceLinea = styled.div`
            height: 1px;
            width: 200px;
            background-color: #808080;
            margin: 2px 0 7px 0;
         `

         const ServiceNumber = styled.p`
            position: absolute;
            font-size: 30px;
            color: #717171;
            font-weight: 900;
            top: -50px;
            opacity: .1;
            z-index: -1;
            transition: .2s;
         `

         const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .3 !important;
                color: #65ff00;
            }
        `
         
         const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #bbb;
            padding-right: 25px;            
        `

         const ServicePrecio = styled.p`
            font-size: 30px;
            font-weight: 300;
            color: #fff;
            padding-right: 25px;            
        `        

        const Submit = styled.a`
            background-color: #fff !important;
            color: #4b7d2f !important;
            border: solid 1px #4b7d2f;
            cursor: pointer !important;
            border-radius: 3px;
            font-size: 14px;
            line-height: 1;
            margin: 0;
            padding: 17px 26px;
            position: relative;
            letter-spacing: 0.02em;
            font-family: "Open Sans Semibold";
            box-shadow: 0 2px 8px 0 rgba(62, 62, 79, .23);
	        -webkit-transition: all 300ms linear 0ms;
	        -moz-transition: all 300ms linear 0ms;
	        -ms-transition: all 300ms linear 0ms;
            transition: all 300ms linear 0ms;
            display: inline-block;
            font-weight: 400;            
            text-transform: uppercase;          
            &:hover {              
                transform: translateX(-20%);
                text-decoration: none;
                background-color: #c1eb18 !important;
	            color: #000 !important;
	            border: none;
                box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .30);
	            -webkit-transform: translateY(-5px);
	            transform: translateY(-5px);              
            }            
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #aaa;            
        `        

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 20px;
        `
        const Heading2 = styled.h2`
            font-size: 70px;
            font-family: Poppins;
            color: #c1eb18;
            line-height: 80px;
            text-align: center;
            font-weight: 800;
            padding-bottom: 80px;
            @media (max-width: 767px) {
                font-size: 40px;           
            }        
        `
        const Heading3 = styled.h3`
            font-size: 40px;
            font-family: Poppins;
            color: #fff;
            line-height: 50px;
        `
        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #aaa;
            padding-bottom: 30px;
        `
        const Text1 = styled.p`
            font-size: 40px;
            font-weight: 700;
            color: #fff;
            padding-bottom: 30px;
            text-align: center;
        `

        const ColorCpanel = styled.span`            
            font-weight: bold;
            color: #ff6d37;            
        `

        const { data } = this.props;
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }
        
        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)

        return(
            <Section>
                <Container>
                    <Row>
                        <Col md={12}>                            
                                <Heading2>Servidores VPS Premium NVMe</Heading2>
                                <Text1>La mejor opción al Dedicado</Text1>
                                <Separator />
                                <Heading3>VPS Administrado Premium</Heading3>
                                <Text>
                                    Nuestros Servidores VPS Premium ofrecen un rendimiento excepcional, con almacenamiento SSD NVMe
                                    equiparándose o superando incluso a las soluciones dedicadas. Experimenta
                                    la potencia y la flexibilidad sin igual que rivaliza con la experiencia de un servidor dedicado.
                                </Text>                            
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <ServiceRow>
                        <Col md={3}>
                            
                                <ServiceElement>
                                    <ServiceHeading>
                                        <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=252">
                                            VPS Premium NVMe 1
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        <Color>4Gb.</Color> RAM
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>&nbsp; 150</Color> Gb. SSD NVMe de espacio
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>6 CPU Cores 100% </Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Ancho de banda <Color>NO MEDIDO</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        1 dirección IP
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        CloudFlare <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Certificado SSL <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Backups <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Migraciones <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Panel de control<br></br> <ColorCpanel>cPanel</ColorCpanel> DISPONIBLE
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Garantía de devolución <Color>30 días</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'NVMe 1').price}/mes
                                    </ServicePrecio>
                                    <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=252">
                                        <span>
                                            Contratar
                                        </span>
                                    </Submit>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={3}>
                            
                                <ServiceElement>
                                    <ServiceHeading>
                                        <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=253">
                                            VPS Premium NVMe 2
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        <Color>5Gb.</Color> RAM
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>250</Color> Gb. SSD NVMe de espacio
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>8 CPU Cores 100% </Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Ancho de banda <Color>NO MEDIDO</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        1 dirección IP
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        CloudFlare <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Certificado SSL <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Backups <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Migraciones <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Panel de control<br></br> <ColorCpanel>cPanel</ColorCpanel> DISPONIBLE
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Garantía de devolución <Color>30 días</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'NVMe 2').price}/mes
                                    </ServicePrecio>
                                    <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=253">
                                        <span>
                                            Contratar
                                        </span>
                                    </Submit>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={3}>
                            
                                <ServiceElement>
                                    <ServiceHeading>
                                        <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=254">
                                            VPS Premium v 3
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        <Color>6Gb.</Color> RAM
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>300</Color> Gb. SSD NVMe de espacio
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>8 CPU Cores 100% </Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Ancho de banda <Color>NO MEDIDO</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        1 dirección IP
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        CloudFlare <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Certificado SSL <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Backups <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Migraciones <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Panel de control<br></br> <ColorCpanel>cPanel</ColorCpanel> DISPONIBLE
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Garantía de devolución <Color>30 días</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'NVMe 3').price}/mes
                                    </ServicePrecio>
                                    <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=254">
                                        <span>
                                            Contratar
                                        </span>
                                    </Submit>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={3}>
                            
                                <ServiceElement>
                                    <ServiceHeading>
                                        <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=255">
                                            VPS Premium NVMe 4
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        <Color>7Gb.</Color> RAM
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>400</Color> Gb. SSD NVMe de espacio
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>8 CPU Cores 100% </Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Ancho de banda <Color>NO MEDIDO</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        1 dirección IP
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        CloudFlare <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Certificado SSL <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Backups <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceText>
                                        Migraciones <Color>GRATIS</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Panel de control<br></br> <ColorCpanel>cPanel</ColorCpanel> DISPONIBLE
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Garantía de devolución <Color>30 días</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'NVMe 4').price}/mes
                                    </ServicePrecio>
                                    <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=255">
                                        <span>
                                            Contratar
                                        </span>
                                    </Submit>
                                </ServiceElement>
                            
                        </Col>
                    </ServiceRow>
                </Container>
                <Container>
                    <Row>
                        <Col md={12}>
                            
                                <Heading2>Servidores VPS administrados</Heading2>
                                <Separator />
                                <Text>Ingresar al mundo de los Servidores VPS Administrados es
                                    abrir la puerta a una experiencia de alojamiento sin preocupaciones.
                                </Text>
                                <Text>Un VPS Administrado va más allá de ser solo un servidor; es tu aliado digital.
                                    La gestión experta que ofrece libera tu tiempo y energía, permitiéndote enfocarte
                                    en lo que realmente importa: hacer crecer tu proyecto.
                                </Text>
                            
                        </Col>
                    </Row>
                </Container>
            </Section>            
        )
    }

}

export const query = graphql`
  query {
    allPricesJson(filter: { page: { eq: "vpsadmin" }, section: { eq: "planes" } }) {
      nodes {
        items {
          name
          price
        }
      }
    }
  }
`

const VpsPage = (props) => (
    <StaticQuery
      query={query}
      render={(data) => (
        <Admin
          data={data}
        />
      )}
    />
  )
  export default VpsPage;